import ApiService from '../ApiService'

const calendarService = {

    create (data) {
      return ApiService.post('/calendar-configuration/', data)
    },

    edit (data) {
      return ApiService.post('/calendar-configuration/edit', data)
    },

    getAllowedDates (branch,spoiled,poliza) {
      if(spoiled)
      return ApiService.get(`/calendar-configuration/getAllowedDates?branch=${branch}&spoiled=${spoiled}`)
      else if(poliza)
      return ApiService.get(`/calendar-configuration/getAllowedDates?branch=${branch}&poliza=${poliza}`)
      else
      return ApiService.get(`/calendar-configuration/getAllowedDates?branch=${branch}`)
    },

    getCalendarConfiguration (data) {
      return ApiService.post(`/calendar-configuration/getCalendarConfiguration`, data)
    }
}

export default calendarService
